import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";
import { jsonToQuery } from "@/utils/queryHelper";

/**
 * Ferry Home Service
 * Ana sayfa feribot API'leri için servis
 */
export const ferryHomeService = {
  /**
   * En ucuz rotaları getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CurrencyCode": "TRY"
   * }
   */
  getCheapestRoutes: (query = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.home.getCheapestRoutes}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),

  /**
   * Son dakika satışlarını getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {string} payload.ClientChannel - İstemci kanalı (örn: "web", "mobile")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CurrencyCode": "TRY",
   *   "ClientChannel": "web"
   * }
   */
  getLastMinuteSales: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.ferry.home.getLastMinuteSales,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Popüler otobüs firmalarını getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr"
   * }
   */
  getPopularFerryCompanies: (
    query = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.home.getPopularFerryCompanies}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),

  /**
   * Popüler rotaları getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr"
   * }
   */
  getPopularLocations: (query = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.home.getPopularLocations}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),

  /**
   * Neden Turna sayfası içeriğini getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr"
   * }
   */
  getWhyTurna: (query = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.home.getWhyTurna}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),

  /**
   * Popüler destinasyonları getir
   * @param {Object} payload - API payload
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {}
   */
  getPopularDestinations: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.ferry.home.getPopularDestinations,
      payload,
      headers,
      hasErrorHandler,
    }),
};
